<p-breadcrumb
  [model]="menuItems"
  class="epc-breadcrumb"
></p-breadcrumb>